import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container-mobile" }
const _hoisted_3 = {
  key: 1,
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button_view = _resolveComponent("back-button-view")!
  const _component_navigation_bar_view = _resolveComponent("navigation-bar-view")!
  const _component_footer_view = _resolveComponent("footer-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_navigation_bar_view, {
        hideNavigationItem: _ctx.hideNavigationItem,
        class: _normalizeClass(_ctx.headerCssClass),
        style: _normalizeStyle(_ctx.headerCssStyle)
      }, {
        title: _withCtx(() => [
          _renderSlot(_ctx.$slots, "title")
        ]),
        leftPart: _withCtx(() => [
          _renderSlot(_ctx.$slots, "leftBar", {}, () => [
            (_ctx.hasBackButton)
              ? (_openBlock(), _createBlock(_component_back_button_view, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.hasBackButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3))
              : _createCommentVNode("", true)
          ])
        ]),
        rightPart: _withCtx(() => [
          _renderSlot(_ctx.$slots, "rightBar")
        ]),
        overlapHeader: _withCtx(() => [
          _renderSlot(_ctx.$slots, "overlapHeader")
        ]),
        _: 3
      }, 8, ["hideNavigationItem", "class", "style"]),
      _createElementVNode("div", {
        class: _normalizeClass([{ 'bottom-0': !_ctx.hasFooter, mainContentCssClass: _ctx.mainContentCssClass }, "container-main container-width item-result"]),
        style: _normalizeStyle(_ctx.mainContentCssStyle)
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 6),
      _renderSlot(_ctx.$slots, "footer", {}, () => [
        (_ctx.hasFooter)
          ? (_openBlock(), _createBlock(_component_footer_view, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}